import { render, staticRenderFns } from "./GameScreen.vue?vue&type=template&id=6503e300&"
import script from "./GameScreen.vue?vue&type=script&lang=js&"
export * from "./GameScreen.vue?vue&type=script&lang=js&"
import style0 from "./GameScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports